// src/components/layout/Header.jsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CartIcon from '../ui/CartIcon';
import HamburgerButton from '../ui/HamburgerButton';
import HamburgerMenu from '../ui/HamburgerMenu';
import logoImage from '../../assets/logo.png';
import '../../styles/header.css';

const Header = ({ title, showBackButton = false, onBackClick }) => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  // Pages où les icônes ne doivent PAS s'afficher (login, register, splash)
  const authPages = ['/login', '/register', '/splash', '/phone-verification'];
  const shouldShowIcons = !authPages.some(page => location.pathname.includes(page));
  
  // Pages où l'icône panier ne doit PAS s'afficher dans le header
  const cartHiddenPages = ['/cart', '/order', '/delivery'];
  const shouldShowCartIcon = shouldShowIcons && !cartHiddenPages.some(page => location.pathname.includes(page));
  
  // Le hamburger s'affiche dès que l'utilisateur est connecté (shouldShowIcons)
  const shouldShowHamburger = shouldShowIcons;
  
  // Gestion de l'ouverture/fermeture du menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  
  return (
    <>
      <header className="header">
        <div className="header-container">
          {/* Bouton retour - Position absolue à gauche */}
          {showBackButton && (
            <button 
              onClick={onBackClick}
              className="header-back-button"
              aria-label="Retour"
            >
              <svg className="header-back-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          )}
          
          {/* Icônes à droite - Panier + Hamburger */}
          {shouldShowIcons && (
            <div className="header-icons-right">
              {/* Icône panier */}
              {shouldShowCartIcon && (
                <CartIcon size="medium" showBadge={true} />
              )}
              
              {/* Bouton hamburger menu */}
              {shouldShowHamburger && (
                <HamburgerButton isOpen={isMenuOpen} onClick={toggleMenu} />
              )}
            </div>
          )}
          
          {/* Logo centré */}
          <Link to="/welcome-page">
            <img src={logoImage} alt="Boissons du Cameroun" className="header-logo" />
          </Link>
          
          {/* Titre centré en dessous du logo */}
          {title && (
            <div className="header-title">
              {title}
            </div>
          )}
        </div>
      </header>

      {/* Menu hamburger (overlay + menu slide-in) */}
      <HamburgerMenu isOpen={isMenuOpen} onClose={closeMenu} />
    </>
  );
};

export default Header;